import type { ReactNode } from 'react';
import { Icon } from '@/components/foundations';

export type InlineAlertProps = {
  tone?: 'ok' | 'warn' | 'err';
  onClose?: () => void;
  children: ReactNode;
};

const COLOR = { ok: 'var(--green)', warn: 'var(--gold-d)', err: 'var(--red)' } as const;

/** Mensagem curta de retorno numa linha (ex.: "Regra criada"), anunciada por leitor de tela. */
export function InlineAlert({ tone = 'ok', onClose, children }: InlineAlertProps) {
  return (
    <p role={tone === 'err' ? 'alert' : 'status'} style={{ color: COLOR[tone], marginBottom: 0 }}>
      {children}
      {onClose && (
        <button type="button" aria-label="Dispensar" onClick={onClose} style={{ marginLeft: 8, border: 0, background: 'none', color: 'inherit', cursor: 'pointer', verticalAlign: 'middle' }}>
          <Icon name="x" />
        </button>
      )}
    </p>
  );
}
